import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as api from "../../../redux/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { reactIcons } from "../../../utils/icons";
import PhoneInput from "../../PhoneInput";
import DatePicker from "react-datepicker";

const AcknowledgmentDeclaration = () => {
  const [form, setForm] = useState({
    name: "",
    position: "",
    // signature: "",
    date: "",
    email: "",
    mobile: ""
  });

  const [formError, setFormError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [dialCode, setDialCode] = useState("+91");
  const location = useLocation();
  const { key } = location.state || {};
  const [adminIde, setAdminId] = useState(null);
  const [isVerified, setIsVerified] = useState(null);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [userid, setUserId] = useState();
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState("Pending");
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);

  const getData = async () => {
    try {
      if (!id) return;
      const res = await api.getUserList(id);
      if (res.status && res.data) {
        console.log("res", res?.data?.data?.adminId);
        const acknowledgmentDeclaration =
          res?.data?.data?.AcknowledgmentDeclaration;
        setAdminId(res?.data?.data?.adminId);
        setUserId(res?.data?.data?.OrganizationMeta[0]?.id);
        setIsVerified(res?.data?.data?.isVerified);

        setVerificationStatus(
          res?.data?.data?.organizationVerificationStatus || "Pending"
        );

        // if (acknowledgmentDeclaration) {
        //   setIsReadOnly(true);

        //   setForm({
        //     name: acknowledgmentDeclaration.name || "",
        //     position: acknowledgmentDeclaration.position || "",
        //     signature: acknowledgmentDeclaration.signature || "",
        //     date: acknowledgmentDeclaration.date?.split("T")[0] || "",
        //     email: acknowledgmentDeclaration.email || "",
        //     mobile: acknowledgmentDeclaration.mobile.replace(/^\+?91/, "") || ""
        //   });
        // }
        if (acknowledgmentDeclaration) {
          setIsReadOnly(true);
          setForm({
            name: acknowledgmentDeclaration.name || "",
            position: acknowledgmentDeclaration.position || "",
            signature: acknowledgmentDeclaration.signature || "",
            date: acknowledgmentDeclaration.date?.split("T")[0] || "",
            email: acknowledgmentDeclaration.email || "",
            mobile: acknowledgmentDeclaration.mobile.replace(/^\+?91/, "") || ""
          });
        } else {
          // Prefill from top-level data if form is not filled yet
          const userData = res?.data?.data;
          setForm((prev) => ({
            ...prev,
            name: userData?.name || "",
            date: userData?.dateOfIncorporation?.split("T")[0] || "",
            email: userData?.emailAddress || "",
            mobile: userData?.phoneNumber?.replace(/^\+?91/, "") || ""
          }));
        }
      } else {
        console.error("Error fetching data:", res.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  console.log("useriddd", userid);
  console.log("admineid", adminIde);
  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value
    });
    setFormError({
      ...formError,
      [name]: ""
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    let errors = {};

    if (!form.name) errors.name = "Full Name is required";
    if (!form.position) errors.position = "Position is required";
    // if (!form.signature) errors.signature = "Signature is required";
    if (!form.date) errors.date = "Date is required";
    if (!form.email) errors.email = "Email is required";
    if (!form.mobile) errors.mobile = "Phone number is required";

    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        ...form,
        mobile: `${dialCode}${form.mobile}`,

        organizationId: id
      };

      const res = await api.acknowledgment(payload);
      if (res.status) {
        toast.success("Data added successfully");
        navigate("/");
      } else {
        toast.error(res?.error?.message);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response?.data?.message,
        "An error occurred while submitting the form"
      );
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleReject = async () => {
    try {
      if (!rejectReason.trim()) {
        toast.error("Please provide a reason for rejection.");
        return;
      }

      await api.verifyOrRejectUser(id, "Rejected", {
        reasons: rejectReason
      });

      setRejectModalOpen(false);
      setSelectedUser(null);
      setRejectReason("");
      toast.success(`User has been rejected.`);
    } catch (error) {
      toast.error("Failed to reject user.");
      console.error(error);
    }
  };

  const handleVerify = async () => {
    try {
      await api.verifyOrRejectUser(id || id, "Verified");
      toast.success("User has been verified.");
      setVerifyModalOpen(false);
      // debouncedFetchUsers();
    } catch (error) {
      toast.error("Failed to verify user.");
      console.error(error);
    }
  };
  console.log("check key", key);
  return (
    <div>
      <h2 className="text-black text-24 text-center pb-10">
        Acknowledgment Declaration
      </h2>
      <form
        className="border mt-5 border-yellow-dark p-5 rounded-[10px]"
        onSubmit={(e) => {
          if (key) {
            handleSubmit(e);
          } else if (id) {
            navigate("/mines");
          } else {
            handleSubmit(e);
          }
        }}
      >
        <div className="grid grid-cols-2 gap-4 items-center">
          <div className="space-y-2">
            <label className="text-black mb-2">
              Full Name<span className="text-red-600">*</span>
            </label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Enter full name"
              readOnly={true}
              className={`text-input cursor-not-allowed ${
                isReadOnly ? "readonly-input" : ""
              }`}
            />
            {formError.name && (
              <div className="text-red-500">{formError.name}</div>
            )}
          </div>

          <div className="space-y-2">
            <label className="text-black">
              Position<span className="text-red-600">*</span>
            </label>
            <input
              type="text"
              name="position"
              value={form.position}
              onChange={handleChange}
              placeholder="Enter position"
              readOnly={isReadOnly}
              className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              }}
              maxLength={50}
            />
            {formError.position && (
              <div className="text-red-500">{formError.position}</div>
            )}
          </div>

          {/* <div className="space-y-2">
            <label className="text-black">Signature</label>
            <input
              type="text"
              name="signature"
              value={form.signature}
              onChange={handleChange}
              placeholder="Enter signature"
              className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
              readOnly={isReadOnly}
            />
            {formError.signature && (
              <div className="text-red-500">{formError.signature}</div>
            )}
          </div> */}

          <div className="input_ mb-3 lg:mb-0">
            <label className="mb-2 block text-black relative">
              Date of Incorporation<span className="text-red-600">*</span>
            </label>
            <DatePicker
              selected={form.date ? new Date(form.date) : null}
              onChange={(date) =>
                setForm({
                  ...form,
                  date: date ? date.toISOString().split("T")[0] : ""
                })
              }
              // className="block bg-primary-500 text-black py-2 px-4 rounded-md placeholder-gray-400"
              wrapperClassName="w-full"
              maxDate={new Date()}
              placeholderText="dd-mm-yyyy"
              name="date"
              dateFormat="yyyy-MM-dd"
              className={`text-input cursor-not-allowed ${
                isReadOnly ? "readonly-input" : ""
              }`}
              readOnly={true}
              showYearDropdown={true}
              scrollableYearDropdown={true}
              yearDropdownItemNumber={100}
            />
          </div>

          <div className="space-y-2">
            <label className="text-black">
              Email<span className="text-red-600">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter email address"
              readOnly={true}
              className={`text-input cursor-not-allowed ${
                isReadOnly ? "readonly-input" : ""
              }`}
            />
            {formError.email && (
              <div className="text-red-500">{formError.email}</div>
            )}
          </div>
          <PhoneInput
            value={form.mobile}
            name="mobile"
            onChange={handleChange}
            dialCode={dialCode}
            onDialCodeChange={(e) => setDialCode(e.target.value)}
            error={formError.mobile}
            disabled={isReadOnly}
            readOnly={true}
            className={`text-input cursor-not-allowed ${
              isReadOnly ? "readonly-input cursor-not-allowed " : ""
            }`}
          />
        </div>
        {rejectModalOpen && selectedUser && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-[400px]">
              <h2 className="text-xl font-semibold mb-4">Reject User</h2>
              <p className="mb-2">
                Are you sure you want to reject{" "}
                <strong>{selectedUser.name}</strong>?
              </p>
              <label className="block mb-2 font-medium">
                Reason for rejection:
              </label>
              <textarea
                className="w-full border border-gray-300 rounded p-2"
                rows="4"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="Write your reason here..."
              ></textarea>
              <div className="flex justify-end gap-3 mt-6">
                <button
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => {
                    setRejectModalOpen(false);
                    setSelectedUser(null);
                    setRejectReason("");
                  }}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50"
                  disabled={!rejectReason.trim()}
                  onClick={handleReject}
                >
                  Confirm Reject
                </button>
              </div>
            </div>
          </div>
        )}
        {verifyModalOpen && selectedUser && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-[400px]">
              <h2 className="text-xl font-semibold mb-4">Verify User</h2>
              <p className="mb-4">
                Are you sure you want to verify{" "}
                <strong>{selectedUser.name}</strong>?
              </p>
              <div className="flex justify-end gap-3">
                <button
                  className="px-4 py-3 border border-primary-100  rounded-lg font-poppins text-16"
                  onClick={() => {
                    setVerifyModalOpen(false);
                    setSelectedUser(null);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-primary-100 text-white text-16 font-poppins rounded-lg font-medium"
                  onClick={handleVerify}
                >
                  Confirm Verify
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-between items-center mt-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-danger"
          >
            {reactIcons.arrowleft} Back
          </button>
          {key || adminIde !== null ? (
            isVerified ? null : (
              <button
                type="submit"
                disabled={isLoading}
                className="py-3 px-6 font-bold rounded-lg btn-primary"
              >
                {isLoading ? "Loading..." : "Submit"}
              </button>
            )
          ) : id && verificationStatus === "Pending" ? (
            <div className="flex gap-4">
              <button
                type="button"
                onClick={() => {
                  setRejectModalOpen(true);
                  setSelectedUser({ name: form.name });
                }}
                disabled={isLoading}
                className="py-3 px-6 font-bold rounded-lg btn btn-danger text-white"
              >
                {isLoading ? "Rejecting..." : "Reject"}
              </button>
              <button
                type="button"
                onClick={() => {
                  setVerifyModalOpen(true);
                  setSelectedUser({ name: form.name });
                }}
                disabled={isLoading}
                className="py-3 px-6 font-bold rounded-lg bg-green-600 text-white"
              >
                {isLoading ? "Approving..." : "Approve"}
              </button>
            </div>
          ) : (
            <div className="italic text-gray-500 text-sm">
              This user is already {verificationStatus.toLowerCase()}.
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default AcknowledgmentDeclaration;
